<template>
<div class="post">
    
    <div class="head-top">
        <p class="tags minor" v-show="post.tags" @click="togglePopMess('Tags are coming soon')">
            <span v-if="truncateTags">{{ post.tags|truncate(110) }}
                <span class="button-text" v-show="post.tags.length > 110" @click="truncateTags = false">+</span>
            </span>
            <span v-else>
                {{ post.tags }}
                <span class="button-text" @click="truncateTags = true">x</span>
            </span>
        </p>
        <h1 class="title" v-show="post.title">
            <span v-if="truncateTitle">
                <router-link :to="linkURL"><span class="button-text">{{ post.title|truncate(90) }}</span></router-link>
                <span class="button-text" v-show="post.title.length > 90" @click="truncateTitle = false">+</span>
            </span>
            <span v-else>
                <router-link :to="linkURL"><span class="button-text">{{post.title}}</span></router-link>
                <span class="button-text" @click="truncateTitle = true">x</span>
            </span>
        </h1>
        <p class="desc minor" v-show="post.desc">
            <span v-if="truncateDesc">{{ post.desc|truncate(110) }} 
                <!-- <span class="button-text" v-show="post.desc.length > 110" @click="truncateDesc = false">+</span> -->
            </span>
            <span v-else>
                {{ post.desc }}
                <!-- <span class="button-text" @click="truncateDesc = true">x</span> -->
            </span>
        </p>
    </div>
    
    <!-- ONLY ON DESKTOP -->
    <div class="head-bottom">
        <p class="time minor">
            {{postedTime}}
        </p>
        <div class="author">
            <p class="desc minor">
                <span>/ </span>
                <span class="button-text" @click="togglePopMess('Profiles are coming soon')" v-show="!isAuthor">{{post.author.firstname + ' ' + post.author.lastname}}</span>
                <span class="" v-show="isAuthor">
                    <span v-if="!delVerify">
                        <span class="dark-grey">Your Post - </span>
                        <span class="button-text" @click="delVerify = true">Delete</span>
                    </span>
                    <span v-if="delVerify">
                        <span class="dark-grey">Are you sure you want to delete? </span>
                        <span class="button-text" @click="delPost()">YES</span>
                        <span class="dark-grey"> / </span>
                        <span class="button-text" @click="delVerify = false">NO cancel</span>
                    </span>
                </span>
            </p>
        </div>
        <p class="read-more minor button-text" v-if="truncateDesc" v-show="post.desc.length > 110" @click="truncateDesc = false">
            Read More
        </p>
        <p class="read-more minor button-text" v-if="!truncateDesc" @click="truncateDesc = true">
            Read Less
        </p>
    </div>
    
<!-- VIDEO CONTAINTER -->
    <div class="vid-cont">

        <Video 
        :videoLink="videoLink" 
        :post="post"
        :postedTime="postedTime"
        :userinfo="userinfo"
        :delBtnVal="delBtnVal"
         />

        <div class="vote-action-cont">
            <div class="vote-cont">
                <div class="vote" v-for="(i, index) in post.debaters" :key="index">
                    <div v-if="i.name">
                        <div class="vote-row">

                            <div class="lt-side">
                                <p class="button-text" @click="togglePopMess('Profiles are coming soon')">{{ i.name }}</p>
                                <small class="button-text" @click="displayPostComment()">
                                    <!-- <span class="dark-grey">0&nbsp;</span><span>Fallacies</span> -->
                                    <span class="dark-grey">{{ getTotalFallacyCount(index) }} </span><span class="hover-margin-lt">Fallacies</span>
                                </small>
                            </div>
                            <!-- <p class="button-text" @click="togglePopMess('Profiles are coming soon')">{{ i.name }}</p> -->
                            
                            <div class="count-vote-cont">
                                <p class="icon-margin-lt">{{ i.voteCount }}&nbsp;</p>
                                <div v-if="userinfo" class="underline-button uppercase" :class="{ strike: findUserPostActions.vote == i.name }" @click="vote(i, index)"><span>Vote</span></div>
                                <div v-if="!userinfo" class="underline-button uppercase" @click="toggleLogin(); togglePopMess('You have to Login to Vote');"><span>Vote</span></div>
                                <!-- <small class="button-text" @click="togglePopMess('Fallacy votes are coming soon')">
                                    <span class="dark-grey">&nbsp;/ 0</span> F
                                </small> -->
                            </div>

                        </div>

                        <div class="vote-bar">
                            <div class="vote-bar-dist" :style="{ width: voteBarLength(i.voteCount) + '%' }"></div>
                            <!-- <small class="vs" v-if="index == 1"><span class="dark-grey" v-if="index == 1">vs</span></small> -->
                        </div>
                        
                    </div>
                </div>
                
            </div>


            <div class="main-fallacies-cont">
                <small class="fallacies-cont" @click="displayPostComment()">
                    <div class="comment button-text">
                        <span>Comment... </span>
                    </div>
                    <div class="fallacy button-text" @mouseover="fallacyDesc = 'Attacking his opponent instead of his opponent’s argument.'" @mouseleave="fallacyDesc = false">
                        <span class="dark-grey">{{ fallacyCount('Ad Hominem') }} </span>
                        <span class="hover-margin-lt">Ad Hominem</span>
                    </div>
                    <div class="fallacy button-text" @mouseover="fallacyDesc = 'Claiming his argument is right because someone famous or powerful supports it.'" @mouseleave="fallacyDesc = false">
                        <span class="dark-grey">{{ fallacyCount('Appeal to Authority') }} </span>
                        <span class="hover-margin-lt">Appeal to Authority</span>
                    </div>
                    <div class="fallacy button-text" @mouseover="fallacyDesc = 'Asserting that a proposition is true or false because it has not yet been proven.'" @mouseleave="fallacyDesc = false">
                        <span class="dark-grey">{{ fallacyCount('Appeal to Ignorance') }} </span>
                        <span class="hover-margin-lt">Appeal to Ignorance</span>
                    </div>
                    <div class="fallacy button-text" @mouseover="fallacyDesc = 'Deliberate excessive use of acronyms and abbreviations to appear more knowledgeable in the subject.'" @mouseleave="fallacyDesc = false">
                        <span class="dark-grey">{{ fallacyCount('Alphabet Soup') }} </span>
                        <span class="hover-margin-lt">Alphabet Soup</span>
                    </div>
                    <div class="fallacy button-text" @mouseover="fallacyDesc = 'Concludes that a proposition must be true because many or most people believe it.'" @mouseleave="fallacyDesc = false">
                        <span class="dark-grey">{{ fallacyCount('Bandwagon') }} </span>
                        <span class="hover-margin-lt">Bandwagon</span>
                    </div>
                    <div class="fallacy button-text" @mouseover="fallacyDesc = 'When the premise and conclusion say the same thing.'" @mouseleave="fallacyDesc = false">
                        <span class="dark-grey">{{ fallacyCount('Circular Argument') }} </span>
                        <span class="hover-margin-lt">Circular Argument</span>
                    </div>
                    <div class="fallacy button-text" @mouseover="fallacyDesc = 'Assumption that there are only two possible solutions and ignoring other alternative solutions.'" @mouseleave="fallacyDesc = false">
                        <span class="dark-grey">{{ fallacyCount('False Dilemma') }} </span>
                        <span class="hover-margin-lt">False Dilemma</span>
                    </div>
                    <div class="fallacy button-text" @mouseover="fallacyDesc = 'Diverting the attention away from the relevant issue by introducing another, irrelevant issue.'" @mouseleave="fallacyDesc = false">
                        <span class="dark-grey">{{ fallacyCount('Red Herring') }} </span>
                        <span class="hover-margin-lt">Red Herring</span>
                    </div>
                    <div class="fallacy button-text" @mouseover="fallacyDesc = 'Asserting that a relatively small first step leads to a chain of related events culminating in some significant effect.'" @mouseleave="fallacyDesc = false">
                        <span class="dark-grey">{{ fallacyCount('Slippery Slope') }} </span>
                        <span class="hover-margin-lt">Slippery Slope</span>
                    </div>
                    <div class="fallacy button-text" @mouseover="fallacyDesc = 'Exploiting weaker and less central arguments, while acting like this argument is the crux of the issue.'" @mouseleave="fallacyDesc = false">
                        <span class="dark-grey">{{ fallacyCount('Straw Man') }} </span>
                        <span class="hover-margin-lt">Straw Man</span>
                    </div>
                </small>
            </div>
            <div class="add-fallacy-cont">
                <p class="add-fallacy button-text uppercase" @click="displayPostComment()"><span>Add Fallacy</span></p> 
            </div>

            <div class="fallacy-desc-cont" v-show="fallacyDesc">
                <small class="fallacy-desc dark-grey">{{fallacyDesc}}</small>
            </div>

            <div class="mob-only-cont">
                <!-- <div class="gradient"></div> -->
                <div class="divider"></div>
            </div>

        </div>

    </div>

    <Comments
        :post="post"
        :userinfo="userinfo"
        :showPostComment="showPostComment"
        @emitDisplayPostComment="displayPostComment()"
    />

    <transition name="slide-fade-y">
        <CommentPost
        class="post-comment-form"
        v-if="showPostComment"
        @emitDisplayPostComment="displayPostComment()"
        :userinfo="userinfo"
        :post="post"
        />
    </transition>


</div>
</template>

<script>
import { db, auth, increment, decrement, fbfs } from '../db'
import * as firebase from 'firebase'
import Comments from '@/components/Comments.vue'
import Video from '@/components/Video.vue'
import CommentPost from '@/components/CommentPost.vue'

export default {
  name: 'Post',
  props: [
      "userinfo",
      "useractions",
      "post",
  ],
  components: {
      Comments,
      Video,
      CommentPost
  },
  data() {
      return {
        videoLink: this.post.link,
        postid: this.post.id,
        debaters: this.post.debaters,
        author: this.post.author,
        count: this.post.count,
        debsArr: [],
        likeCount: this.post.likeCount,
        dislikeCount: this.post.dislikeCount,
        haveFeeling: 0,
        debParentRef: '',
        delBtnVal: false,
        userPostActions: null,
        truncateTags: true,
        truncateTitle: true,
        truncateDesc: true,
        voteCount: this.post.voteCount,
        delVerify: false,
        fallacyDesc: false,
        fallacyCountArr: [],
        showPostComment: false,
        showDesc: false,
        linkURL: '/title/' + this.post.id,
      }
  },
  filters: {
    truncate: function(value, limit) {
      if (value.length > limit) {
        value = value.substring(0, (limit - 3)) + '...';
      }
      return value
    }
  },
  computed: {
    findUserPostActions() {
        var that = this
        // var obj = that.useractions.find(obj => { return obj.postUID == that.postid });
// var obj = this.useractions.actions
// var obj = this.useractions.myArr.find(obj => { return obj.postID == that.postid });

//NÅGOT BUGGAR MED DENNA NÄR MAN HAR SKAPAT NY ANVÄNDARE OCH USERS/ACTIONS OBJECTET ÄR TOMT
        if(that.useractions.actions[that.postid]) {
            return that.useractions.actions[that.postid]
        } else {
            return false
        }
    },
    isAuthor(){
        if (this.userinfo) {
            var that = this
            if ( that.userinfo.id == that.post.author.id ) { 
                return that.delBtnVal = true 
            }
        }
    },
    postedTime() {
        let d = this.post.timeStamp.toDate()        
        // let datestring = ("0" + d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
        let datestring = ("0" + (d.getMonth()+1)).slice(-2) + "-" + ("0"+(d.getDate())).slice(-2) + "-" + d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);

        return datestring
    },
  },
  methods: {
    displayPostComment () {
        this.showPostComment = this.showPostComment != true
    },
    fallacyCount(elm) {
        const arr = this.post.comments
        const res = arr.filter(x => x.fallacyMark === elm)
        return res.length
    },
    getTotalFallacyCount(index) {
        const arr = this.post.comments
        const deb = this.post.debaters[index].name
        return arr.filter(x => x.debaterMark === deb).length
    },
    vote(i, index) {

        const postRef = db.collection('posts').doc(this.postid)
        // const actionRef = db.collection(`users/${this.userinfo.id}/actions`).doc(this.postid)
        const actionRef = db.collection('users').doc(this.userinfo.id)
        const votesRef = db.collection(`posts/${this.postid}/votes`).doc(this.userinfo.id)
        const debaterDocRef = db.collection('debaters').doc(i.name)
        // const highscoreRef = db.collection('highscore').doc('totalvotes')
        const highscoreRef = db.collection('highscore').doc('profiles')

        const that = this
        Object.entries(this.debaters).forEach(function (elm, i) {
            const res = elm.find(obj => { return obj.name == that.findUserPostActions.vote })
            if (res) { 
                    that.debParentRef = res.parentRef 
                }
        });
        const oldDebRef = 'debaters.' + that.debParentRef + '.voteCount'
        const newDebRef = 'debaters.' + index + '.voteCount'        
        
        if (!this.findUserPostActions || !this.findUserPostActions.vote) {
            this.$store.commit('togglePopMess', 'Thank you for voting!')
            // Add vote and add action
            votesRef
            .set({
                userUID: this.userinfo.id,
                postUID: this.postid,
                vote: i.name
            }, {merge: true})
            .then(() => {
                console.log(`+1 Write() votesRef updated`)
                postRef
                .update({
                    [newDebRef]: increment
                })
                .then(() => {
                    console.log(`+1 Write() postRef updated`)
                    this.debaters[index].voteCount += 1
                    actionRef
                    .set({
                        actions: {
                            [this.postid]: {
                                vote: i.name
                            }
                        }
                    }, {merge: true})
                    .then(() => {
                        console.log(`+1 Write() actionRef updated`)
                            highscoreRef.set({
                                    [i.name]: {
                                        totalvotes: increment,
                                        debates: {
                                            [this.postid]: {
                                                votes: increment
                                            }
                                        }
                                    }
                            }, {merge: true})
                            .then(() => {
                                console.log(`+1 Write() highscoreRef updated`)
                            }).catch(err => { console.error(err) })
                    }).catch(err => { console.error(err) })
                }).catch(err => { console.error(err) })
            }).catch(err => { console.error(err) })
        }
        else if (this.findUserPostActions.vote == 0) {
            this.$store.commit('togglePopMess', 'Thank you for voting!')
            // Add vote and add action
            votesRef
            .update({
                vote: i.name
            })
            .then(() => { 
                console.log(`+1 Write() votesRef updated`)
                postRef
                .update({
                    [newDebRef]: increment
                })
                .then(() => {
                    console.log(`+1 Write() postRef updated`)
                    this.debaters[index].voteCount += 1
                    actionRef
                    .set({
                        // vote: i.name
                        actions: {
                            [this.postid]: {
                                vote: i.name
                            }
                        }
                    }, {merge:true})
                    .then(() => {
                        console.log(`+1 Write() actionRef updated`)
                            highscoreRef.set({
                                    [i.name]: {
                                        totalvotes: increment,
                                        debates: {
                                            [this.postid]: {
                                                votes: increment
                                            }
                                        }
                                    }
                            }, {merge: true})
                            .then(() => {
                                console.log(`+1 Write() highscoreRef updated`)
                            }).catch(err => { console.error(err) })
                    }).catch(err => { console.error(err) })
                }).catch(err => { console.error(err) })
            }).catch(err => { console.error(err) })

        }
        else if (this.findUserPostActions.vote == i.name) {
            this.$store.commit('togglePopMess', 'Vote Removed!')
            // TODO remove vote
            votesRef
            .update({
                vote: 0
            })
            .then(() => {console.log(`+1 Write() votesRef updated`)
                const debaterRef = 'debaters.' + index + '.voteCount'
                postRef
                .update({
                    [debaterRef]: decrement
                })
                .then(() => {console.log(`+1 Write() postRef updated`)
                    this.debaters[index].voteCount -= 1
                    actionRef
                    .set({
                        actions: {
                            [this.postid]: {
                                vote: 0
                            }
                        }
                    }, {merge:true})
                    .then(() => {console.log(`+1 Write() actionRef updated`)
                            highscoreRef.set({
                                    [i.name]: {
                                        totalvotes: decrement,
                                        debates: {
                                            [this.postid]: {
                                                votes: decrement
                                            }
                                        }
                                    }
                            }, {merge: true})
                            .then(() => {
                                console.log(`+1 Write() highscoreRef updated`)
                            }).catch(err => { console.error(err) })
                        }).catch(err => { console.error(err) })
                }).catch(err => { console.error(err) })
            }).catch(err => { console.error(err) })


        } else {
            this.$store.commit('togglePopMess', 'Vote Changed!')
            // changing vote
            votesRef
            .update({
                vote: i.name
            })
            .then(() => {console.log(`+1 Write() votesRef`)
                postRef.update({
                    [newDebRef]: increment,
                    [oldDebRef]: decrement
                })
                .then(() => {console.log(`+1 Write() postRef`)
                    this.debaters[index].voteCount += 1
                    this.debaters[that.debParentRef].voteCount -= 1                    
                    actionRef.set({
                        actions: {
                            [this.postid]: {
                                vote: i.name
                            }
                        }
                    }, {merge:true})
                    .then(() => {console.log(`+1 Write() actionRef`)
                            // Denna if sats är för att hitta den tidigare valda debatören
                            if (this.debaters[1].name == i.name) {
                                var otherDebaterVotesRef = this.debaters[2].name
                            } else {
                                var otherDebaterVotesRef = this.debaters[1].name
                            }
                                highscoreRef.set({
                                        [i.name]: {
                                            totalvotes: increment,
                                            debates: {
                                                [this.postid]: {
                                                    votes: increment
                                                }
                                            }
                                        },
                                        [otherDebaterVotesRef]: {
                                            totalvotes: decrement,
                                            debates: {
                                                [this.postid]: {
                                                    votes: decrement
                                                }
                                            }
                                        }
                                }, {merge: true})
                                .then(() => {
                                    console.log(`+1 Write() highscoreRef updated`)
                                }).catch(err => { console.error(err) })
                            }).catch(err => { console.error(err) })
                }).catch(err => { console.error(err) })
            }).catch(err => { console.error(err) })
        }


    },

    like() {
        const postRef = db.collection('posts').doc(this.postid)
        const actionRef = db.collection('users').doc(this.userinfo.id)

        // Checking if action exist
        if ( this.findUserPostActions ) {
            // Getting feeling (0 = none, 1 = like, 2 = dislike)
            if ( this.findUserPostActions.feeling == 0 ) {
                // Changing feeling 0 to 1
                actionRef.set({
                    actions: {
                        [this.postid]: {
                            feeling: 1
                        }
                    }
                }, {merge:true})
                .then(() => { 
                    console.log(`+1 Write() actionRef`) 
                }).catch(err => { console.error(err) })
                postRef.update({
                    likeCount: increment
                }).then(() => { console.log(`+1 Write() postRef`) }).catch(err => { console.error(err) })
                this.likeCount += 1
                this.$store.commit('togglePopMess', 'Like Added')
            }
            else if ( this.findUserPostActions.feeling == 1 ) {
                // Changing feeling 1 to 0
                actionRef.set({
                    actions: {
                        [this.postid]: {
                            feeling: 0
                        }
                    }
                }, {merge:true}).then(() => { console.log(`+1 Write() actionRef`) }).catch(err => { console.error(err) })
                postRef.update({
                    likeCount: decrement
                }).then(() => { console.log(`+1 Write() postRef`) }).catch(err => { console.error(err) })
                this.likeCount -= 1
                this.$store.commit('togglePopMess', 'Like Removed')
            }
            else if ( this.findUserPostActions.feeling == 2 ) {
                // Changing feeling 2 to 1
                actionRef.set({
                    actions: {
                        [this.postid]: {
                            feeling: 1
                        }
                    }
                }, {merge: true}).then(() => { console.log(`+1 Write() actionRef`) }).catch(err => { console.error(err) })
                postRef.update({
                    likeCount: increment,
                    dislikeCount: decrement
                }).then(() => { console.log(`+1 Write() postRef`) }).catch(err => { console.error(err) })
                this.likeCount += 1
                this.dislikeCount -= 1
                this.$store.commit('togglePopMess', 'Like Changed')
            } 
            else {
                // Changing feeling 0 to 1
                actionRef.set({
                    actions: {
                        [this.postid]: {
                            feeling: 1
                        }
                    }
                }, {merge:true})
                .then(() => { 
                    console.log(`+1 Write() actionRef`) 
                }).catch(err => { console.error(err) })
                postRef.update({
                    likeCount: increment
                }).then(() => { console.log(`+1 Write() postRef`) }).catch(err => { console.error(err) })
                this.likeCount += 1
                this.$store.commit('togglePopMess', 'Like Added')
            }
            
        } else {
            actionRef.set({
                actions: {
                    [this.postid]: {
                        feeling: 1
                    }
                }
            }, {merge: true})
            .then(() => { console.log(`+1 Write() actionRef`) }).catch(err => { console.error(err) })
            postRef.update({
                likeCount: increment
            }).then(() => { console.log(`+1 Write() postRef`) }).catch(err => { console.error(err) })
            this.likeCount += 1
            this.$store.commit('togglePopMess', 'Like Added')
        }
        
    },

    dislike() {
        const postRef = db.collection('posts').doc(this.postid)
        // const actionRef = db.collection(`users/${this.userinfo.id}/actions`).doc(this.postid)
        const actionRef = db.collection('users').doc(this.userinfo.id)

        // Checking if action exist
        if ( this.findUserPostActions ) {
            // Getting feeling (0 = none, 1 = like, 2 = dislike)
                if ( this.findUserPostActions.feeling == 0) {
                    // Changing feeling 0 to 2
                    actionRef.set({
                        actions: {
                            [this.postid]: {
                                feeling: 2
                            }
                        }
                    }, {merge: true}).then(() => { console.log(`+1 Write() actionRef`) }).catch(err => { console.error(err) })
                    postRef.update({
                        dislikeCount: increment
                    }).then(() => { console.log(`+1 Write() postRef`) }).catch(err => { console.error(err) })
                    this.dislikeCount += 1
                    this.$store.commit('togglePopMess', 'Dislike Added')
                }
                else if ( this.findUserPostActions.feeling == 1 ) {
                    // Changing feeling 1 to 2
                    actionRef.set({
                        actions: {
                            [this.postid]: {
                                feeling: 2
                            }
                        }
                    }, {merge: true}).then(() => { console.log(`+1 Write() actionRef`) }).catch(err => { console.error(err) })
                    postRef.update({
                        likeCount: decrement,
                        dislikeCount: increment
                    }).then(() => { console.log(`+1 Write() postRef`) }).catch(err => { console.error(err) })
                    this.likeCount -= 1
                    this.dislikeCount += 1
                    this.$store.commit('togglePopMess', 'Dislike Changed')
                }
                else if ( this.findUserPostActions.feeling == 2 ) {
                    // Changing feeling 2 to 0
                    actionRef.set({
                        actions: {
                            [this.postid]: {
                                feeling: 0
                            }
                        }
                    }, {merge: true}).then(() => { console.log(`+1 Write() actionRef`) }).catch(err => { console.error(err) })
                    postRef.update({
                        dislikeCount: decrement
                    }).then(() => { console.log(`+1 Write() postRef`) }).catch(err => { console.error(err) })
                    this.dislikeCount -= 1
                    this.$store.commit('togglePopMess', 'Dislike Removed')
                }
                else {
                    // Add feeling 0 to 2
                    actionRef.set({
                        actions: {
                            [this.postid]: {
                                feeling: 2
                            }
                        }
                    }, {merge:true}).then(() => { console.log(`+1 Write() actionRef`) }).catch(err => { console.error(err) })
                    postRef.update({
                        dislikeCount: increment
                    }).then(() => { console.log(`+1 Write() postRef`) }).catch(err => { console.error(err) })
                    this.dislikeCount += 1
                }

        } else {
            actionRef.set({
                        actions: {
                            [this.postid]: {
                                feeling: 1
                            }
                        }
            }, {merge: true})
            .then(() => { console.log(`+1 Write() actionRef`) }).catch(err => { console.error(err) })
            postRef.update({
                dislikeCount: increment
            }).then(() => { console.log(`+1 Write() postRef`) }).catch(err => { console.error(err) })
            this.dislikeCount += 1
            this.$store.commit('togglePopMess', 'Dislike Added')
        }
    },
    delPost() {
        if ( this.userinfo.id == this.author.id ) {
            db.collection('posts').doc(this.postid)
            .delete()
            .then(() => { 
                console.log('+1 Write() Post deleted.') 
                this.$router.go(0)
            }).catch(err => { console.error(err.message) })
        } else {
            console.log('Not your post to delete')
        }
        
    },
    voteBarLength(x){
        let totalVotes = 0
        Object.values(this.debaters).forEach(function (elm, i) {
            return totalVotes += elm.voteCount
        })
        let result = (x / totalVotes) * 100
        return result
    },
    togglePopMess(payload) {
      this.$store.commit('togglePopMess', payload)
    },
    toggleLogin() {
      this.$store.commit('toggleLogin')
    },

  }
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";

.post {
    // border: 1px solid blue;
    margin: 15% 0;
    .head-top {
      display: flex;
      margin: 0 $grid-padding;
        .tags, .desc {
            min-width: $col2;
            max-width: $col2;
            // border: 1px solid orange;
            margin-top: 6px;
        }
        .tags {
            margin-right: $main-margin;
            cursor: pointer;
            
            span {
                hyphens: auto;
            }
        }
        .desc {
            margin-left: $main-margin;
            span {
                hyphens: auto;
            }
            
        }
        .title {
            margin: 0;
            // border: 1px solid green;
            width: 100%;
        }
    }
    .head-bottom {
        display: flex;
        margin: 0 $grid-padding;
        align-items: center;
        box-sizing: border-box;
        .time {
            min-width: $col2;
            max-width: $col2;
            margin-right: $main-margin;
        }
        .author {
            align-items: center;
            margin-right: $main-margin;
        }
        .read-more {
            text-align: right;
            white-space: pre;
            margin: 0 0 0 auto;
        }
    }
    .vid-cont {
        display: flex;
        margin: 0 $grid-padding;
        padding: $main-margin 0;
        border-top: $line-thin solid $line-color-light;
        border-bottom: $line-bold solid $line-color-dark;
        //.video settings in Video component
        .vote-action-cont {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            .vote-cont {
                margin-left: $main-margin;
                .vote {
                    .vote-row {
                        // border: 1px solid red;
                        margin: 4px 0;
                        display: flex;
                        width: 100%;
                        justify-content: space-between;
                        align-items: center;
                        .count-vote-cont {
                            display: flex;
                            align-items: center;
                            @media #{$desktop-wide} { 
                                p, span {
                                    font-size: $h3;
                                }
                            }
                            small {
                                white-space: nowrap;
                            }
                        }
                        .lt-side {
                            display: flex;
                            flex-direction: column;
                            p {
                                margin: 0;
                            }
                        }
                        // &:hover {
                        //     background-color: $black;
                        //     color: $white;
                        // }
                    }
                }
                .vote-bar {
                    position: relative;
                    width: 100%;
                    height: 2px;
                    background-color: $line-color-light;
                    .vote-bar-dist {
                        width: 0; //if no votes at all
                        height: 2px;
                        background-color: $icon-hover-color;
                        
                    }
                    .vs {
                        position: absolute;
                        width: inherit;
                        box-sizing: border-box;
                        margin-top: -9px;
                        padding-right: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        span {
                            background-color: $white;
                        }
                    }
                }
            }   

            .main-fallacies-cont {
                position: relative;
                // border: 1px solid red;
                height: 100%;
                width: 100%;
                overflow: scroll;
                padding-left: $main-margin;
                margin-top: $main-margin;
                box-sizing: border-box;
                .fallacies-cont {
                    position: absolute;
                    height: 100%;
                    display: flex;
                    flex-flow: column nowrap;
                    margin: 0;
                    .comment {
                        display: none;
                    }
                    .fallacy {
                        margin: 0;
                        &:nth-child(2) {
                            margin-top: auto;
                        }
                        span {
                            min-width: 13px;
                            display: inline-block;
                        }
                    }
                }
            }  
            .add-fallacy-cont {
                position: relative;
                .add-fallacy {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    margin: 0;
                }
            }
            .fallacy-desc-cont {
                position: relative;
                .fallacy-desc {
                    position: absolute;
                    width: $col2;
                    right: 0;
                    bottom: 0;
                    margin: 0;
                    background-color: $white;
                }
            }

        }
    }

    .post-comment-form {
        //This is for the bottom positioning on mobile to work 
        position: fixed;
        bottom: 0;
        z-index: 20;
    }
}

// MOBILE
@media #{$mobile} {    
    .post {
        .head-top {
            flex-direction: column;
            margin: $main-margin-mobile;
            .tags, .desc {
                max-width: 100%;
                margin: 0;
                font-size: $p2;
            }
            .title, .desc {
                display: none;
            }
            .title {
                margin: $main-margin-mobile 0; 
            }
        }
        .head-bottom {
            margin: $main-margin-mobile;
            justify-content: space-between;
            font-size: $p2;
            display: none;
            .author, .time {
                display: flex;
                width: auto;
                align-items: center;
            }
            .author span, .time {
                font-size: $p2;
                padding: 0;
            }
        }
        .vid-cont {
            flex-direction: column;
            // margin: $main-margin-mobile;
            margin: 0;
            padding: 0;
            border-top: 0;
            border-bottom: 0;
            //.video settings in Video component
            .vote-action-cont {
                .vote-cont {
                    margin: 0 $main-margin-mobile;
                    .vote-bar {
                        height: $line-thin !important;
                        .vote-bar-dist {
                            height: $line-thin !important;
                        }
                    }
                }

                .main-fallacies-cont {
                    margin-top: 0;
                    width: auto;
                    height: 56px;
                    padding: 0;
                    .fallacies-cont { 
                        flex-flow: row nowrap;
                        align-items: flex-end;
                        .comment {
                            display: block;
                            margin-left: $main-margin-mobile;
                        }
                        .comment, .fallacy {
                            white-space: pre;
                            margin-right: $main-margin-mobile;
                            margin-top: 0;
                            margin-bottom: 10px;
                            font-size: $p2;
                        }
                        
                    }
                }
                .fallacy-desc-cont {
                    display: none;
                }
                .mob-only-cont {
                    .gradient {
                        position: absolute;
                        width: 100px;
                        height: 56px;
                        margin-top: -56px;
                        background: linear-gradient(90deg, #fff 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,0) 100%);
                    }
                    .divider {
                        position: relative;
                        width: auto;
                        height: $line-thin;
                        background-color: $black;
                        margin: 0 $main-margin-mobile;
                        box-sizing: border-box;
                    }
                }
                .add-fallacy-cont { 
                    display: none;
                }
            }


        }
    }
}

</style>